/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner } from './CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner';
import {
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSON,
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSONTyped,
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerToJSON,
} from './CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner';

/**
 * The newly created Custom Component Library Revision.
 * @export
 * @interface CustomComponentLibrariesLibraryIdRevisionsPost200Response
 */
export interface CustomComponentLibrariesLibraryIdRevisionsPost200Response {
    /**
     * API request succeeded
     * @type {boolean}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsPost200Response
     */
    success: boolean;
    /**
     * 
     * @type {CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsPost200Response
     */
    data: CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdRevisionsPost200Response interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdRevisionsPost200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdRevisionsPost200ResponseFromJSON(json: any): CustomComponentLibrariesLibraryIdRevisionsPost200Response {
    return CustomComponentLibrariesLibraryIdRevisionsPost200ResponseFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdRevisionsPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdRevisionsPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSON(json['data']),
    };
}

export function CustomComponentLibrariesLibraryIdRevisionsPost200ResponseToJSON(value?: CustomComponentLibrariesLibraryIdRevisionsPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'data': CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerToJSON(value.data),
    };
}

